import React from "react";
import { justPending } from '@/utils/async';
import type { AsyncFun } from '@/utils/async';

const usePendingAsync = <R extends any, T extends AsyncFun<R>>(fun: T): T => {
    const ref = React.useRef();
    return justPending(fun, ref);
};

export { usePendingAsync };

